import { React, useState, useEffect } from "react";
import {
  RightLayoutContainer,
  DetailFields,
  GroupTitle,
  PageTitleComp,
  DownArrowDraw,
  DropDownSearchDraw,
  TableLayoutData,
} from "../../styledElements";
import {
  Button,
  Row,
  Col,
  Form,
  Input,
  Select,
  PageHeader,
  Radio,
  Tabs,
  Tooltip,
  Table,
  Checkbox,
} from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { HaberForm } from "../../styledElements";
import { GlobalSet, StyledTab, Styled } from "../../pageStyled";
import warning from "../../../Assets/Icons/warning.png";
import { ModalPopup } from "../../../Components/Modal/modal";
import { useLocation, useNavigate } from "react-router-dom";
import {
  fetchProductDetails,
  editProduct,
  deleteProduct,
  getStockSizes,
  getProductsDataForConfiguration,
  searchProductStock,
} from "../../../Services/productServices";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import ConfirmationModal from "../../../Components/Modal/ConfirmationModal";
import {
  getAllGrades,
  getGradeQualities,
  getGradeProductParameter,
} from "../../../Services/settingsServices";
import SearchContainer from "../../../Components/SearchBarHeader/searchBar";
import AddNewSize from "../../StockManagement/AddNewSize";
import { capital_letter } from "../../../Utils/helper/helper";
import { getUnitData } from "../../../Services/measurementService";
import {
  currency_List,
  lengthUnit,
  weightUnit,
} from "../../../Utils/Constant/MeasurementUnitList.jsx";
import { getWorkflowSettings } from "../../../Services/workFlowSettingsServices.js";

const capitalize = (item) => item.charAt(0).toUpperCase() + item.slice(1);
const Panes = Tabs.TabPane;
const { Option } = Select;
const gradeTypeData = [
  "Kraft Paper",
  "Duplex Paper",
  "Corrugated Paper",
  "Writing and Printing Paper",
];
const qualityTypeData = ["Copier Gold", "Kraft Paper", "Duplex Paper"];

const userStatusData = [
  { label: "Active", value: "active" },
  { label: "Disabled", value: "disabled" },
];

const { TextArea } = Input;

const EditProductsRecords = (props) => {
  const [userStatus, setUserStatus] = useState(userStatusData[0].value);
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [selectGradeType, setSelectGradeType] = useState();
  const location = useLocation();
  const [productCode, setProductCode] = useState(location.state.productCode);
  const roles = location.state.roles;
  const [product, setProduct] = useState();
  const [editMode, setEditMode] = useState(location.state.action === "edit");
  const [form] = Form.useForm();
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [viewDelete, setViewDelete] = useState(false);
  const [grades, setGrades] = useState([]);
  const [qualities, setQualities] = useState([]);
  const [selectedGrade, setSelectedGrade] = useState();
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  // const [confirmModal, setConfirmModal] = useState(false);
  const [isQualityDropdownOpen, setQualityDropdown] = useState(false);
  const [isGradeDropdownOpen, setGradeDropdown] = useState(false);
  const [deleteError, setDeleteError] = useState(false);
  const [clearSearch, setClearSearch] = useState(false);
  const [newStockSizeDrawer, setNewStockSizeDrawer] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("user-details"))
  );
  const [stockSizesList, setStockSizesList] = useState([]);
  const [isAddNewStockClicked, setIsAddNewStockClicked] = useState(false);
  const [isViewStockClicked, setIsViewStockClicked] = useState(false);
  const [isEditStockClicked, setIsEditStockClicked] = useState(false);
  const [selectedStockSize, setSelectedStockSize] = useState();
  const [rendering, setRendering] = useState(true);
  const [stockSizesListRawData, setStockSizesListRawData] = useState([]);
  const [selectedStockSizeRow, setSelectedStockSizeRow] = useState();
  const [visibleToaster, setVisibleToaster] = useState(false);
  const [actionToaster, setActionToaster] = useState({
    error: "",
    msg: "",
  });
  const [products, setProducts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [productParam, setProductParam] = useState();
  const [unitData, setUnitData] = useState();
  const [checkboxCount, setCheckboxCount] = useState(4);
  const [productTypes, setProductTypes] = useState();
  const [selectedRange, setSelectedRange] = useState([]);
  const [switchFetchOrdersfromERP,setSwitchFetchOrdersfromERP] = useState(false);
  const [referenceCodes, setReferenceCodes] = useState([]);
  
  useEffect(()=>{
    (async()=>{
      const orderManagementSettings = await getWorkflowSettings("order_management");
      setSwitchFetchOrdersfromERP(orderManagementSettings?.data?.fetch_orders_from_erp?.value);
    })();
  },[])

  const checkboxes = Array.from({ length: checkboxCount }, (_, index) => (
    <Col span={6} key={index}>
      <Checkbox value={`${index + 1}`}>
        {" "}
        <span
          style={{
            color: "#323130",
            fontSize: "14px",
            fontFamily: "font-family: var(--sf-pro-text)",
            fontStyle: "normal",
          }}
        >
          {index + 1}
        </span>
      </Checkbox>
    </Col>
  ));
  const types = [
    { label: "Reel", value: "reel" },
    { label: "Sheet", value: "sheet" },
    { label: "Reel & Sheet", value: "both" },
  ];
  const handleCheckboxChange = (checkedValues) => {
    // setSelectedRange(checkedValues);

    setSelectedRange(checkedValues);
  form.setFieldsValue({ ply_range: checkedValues }); 
  };
  const handleProductTypeChange = (type) => {
    setProductTypes(type);
    if (type === "sheet") {
      setSelectedRange(["1"]);
      form.setFieldsValue({ply_range:["1"]})
    } else if (type === "reel" || type === "both") {
      setSelectedRange([])
    }
  };
  const columnsHead = [
    {
      title: "Type",
      dataIndex: "type",
      width: "8%",
      align: "center",
    },
    {
      title: "Size",
      dataIndex: "size",
      width: "8%",
      align: "center",
    },
    {
      title: "Ply",
      dataIndex: "ply",
      width: "8%",
      align: "center",
    },
    {
      title: "Max Allowed Stock",
      dataIndex: "maxAllowedStock",
      width: "12%",
      align: "center",
    },
    {
      title: (
        <div>
          Stock In System
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={"This includes WIP progress & Finished Stock"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      dataIndex: "stockInSystem",
      width: "12%",
      align: "center",
    },
    {
      title: "Available Limit",
      dataIndex: "availableLimit",
      width: "8%",
      align: "center",
    },
    {
      title: "Status",
      dataIndex: "status",
      width: "8%",
      render: (text, record) => (
        <div className="statusVal" dataval={text}>
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={
                text === "Active"
                  ? "This size is active."
                  : text === "Disabled"
                  ? "This size is disabled."
                  : text === "Utilized"
                  ? "This size is utilized."
                  : null
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {" "}
              {text}
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
    {
      title: "Actions",
      dataIndex: "action",
      width: "8%",
      render: (text, record) => (
        <div className="actionBtn">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"Edit this size"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button
                onClick={() => {
                  handleEditAction(record);
                }}
              >
                <Iconmoon icon="edit" size={16} color="#A19F9D" />
              </Button>
            </Tooltip>
          </Styled>
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"View size details"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button
                onClick={() => {
                  handleViewAction(record);
                }}
              >
                <Iconmoon icon="file-view" size={16} color="#A19F9D" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
  ];

  const onChange = (pagination, filters, sorter, extra) => {
    if (pageSize !== pagination.pageSize) {
      setCurrentPage(1);
    } else {
      setCurrentPage(pagination.current);
    }
    setPageSize(pagination.pageSize);
  };

  const handleEditAction = (stockSize) => {
    setSelectedStockSizeRow(stockSize);
    setSelectedStockSize(stockSize.id);
    // if (stockSize.type == "Reel")
    //   setSelectedStockSize(parseFloat(stockSize.size.replace(" CM", "")));
    // else
    //   setSelectedStockSize(parseFloat(stockSize.size.split("*")[0]));

    setIsAddNewStockClicked(false);
    setIsEditStockClicked(true);
    setIsViewStockClicked(false);
    setNewStockSizeDrawer(true);
  };

  const handleViewAction = (stockSize) => {
    setSelectedStockSizeRow(stockSize);
    setSelectedStockSize(stockSize.id);
    // if (stockSize.type == "Reel")
    //   setSelectedStockSize(parseFloat(stockSize.size.replace(" CM", "")));
    // else
    //   setSelectedStockSize(parseFloat(stockSize.size.split("*")[0]));

    setIsAddNewStockClicked(false);
    setIsEditStockClicked(false);
    setIsViewStockClicked(true);
    setNewStockSizeDrawer(true);
  };

  const routeBack = (action, response) => {
    // console.log("in");
    navigate("../products-records/", {
      state: { action: action, response: response },
    });
  };

  const modalShow = () => {
    setVisible(true);
  };

  const modalCancel = () => {
    setVisible(false);
  };

  const modalConfirm = () => {
    // setConfirmModal(true);
    setVisible(false);
    routeBack();
  };
  const OntoggleSelect = () => {
    setQualityDropdown((prevState) => !prevState);
  };
  const OnGradetoggleSelect = () => {
    setGradeDropdown((prevState) => !prevState);
  };

  // useEffect(() => {
  //   if(confirmModal)
  //     saveProductHandler();
  // }, [confirmModal])

  useEffect(() => {
    getAllGrades("enabled")
      .then((response) => {
        setGrades(response.map((grade) => grade.name));
      })
      .catch((error) => {
        console.log(error);
      });
    getProductsDataForConfiguration("")
      .then((response) => {
        setProducts(response);
        // console.log("Grades", grades);
      })
      .catch((error) => {
        console.log(error);
      });
    getUnitData()
      .then((response) => {
        let data = response.data;
        let perWeight = [];
        for (
          let index = 0;
          index < data.units_management.weight.data.length;
          index++
        ) {
          const unit = data.units_management.weight.data[index];
          perWeight.push({
            value: unit,
            label: "Per " + weightUnit[unit].displayName,
          });
        }
        let filteredCurrency = currency_List.filter((item) =>
          data.units_management.currency.data.includes(item.code)
        );
        data.units_management.weight["perDeafultWeight"] =
          "Per " + weightUnit[data.units_management.weight.default].displayName;
        data.units_management.currency["currencyList"] = filteredCurrency;
        data.units_management.weight["perWeight"] = perWeight;
        setUnitData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    (async () => {
      if (selectGradeType) {
        await getGradeQualities(encodeURIComponent(selectGradeType), "enabled")
          .then((response) => {
            setQualities(response.map((quality) => quality.name));
          })
          .catch((error) => {
            console.log(error);
          });

        await getGradeProductParameter(selectGradeType)
          .then((response) => {
            //setQualities(response.map((quality) => quality.name));
            setProductParam(response);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    })();
  }, [selectGradeType]);

  useEffect(async () => {
    if (rendering == true) {
      let stockSizesList = await getStockSizes(productCode);
      setStockSizesListRawData(stockSizesList.data);
      const data = stockSizesList.data?.map((item) => {
        return {
          id: item.id,
          type: capitalize(item.type),
          size:
            item.type === "reel"
              ? +item.width + " " + item.units.width
              : +item.width +
                " * " +
                +item.length +
                " " +
                lengthUnit[item.units.width].displayName.toUpperCase(),
          maxAllowedStock:
            item.quantity +
            " " +
            capitalize(weightUnit[item.units.quantity].displayName),
          stockInSystem:
            item.stock_in_system.toFixed(3) +
            " " +
            capitalize(weightUnit[item.units.quantity].displayName),
          availableLimit:
            (item.quantity - item.stock_in_system).toFixed(3) < 0
              ? 0 + " T"
              : (item.quantity - item.stock_in_system).toFixed(3) +
                " " +
                capitalize(weightUnit[item.units.quantity].displayName),
          status: capitalize(item.status),
          ply: item.ply,
        };
      });
      setStockSizesList(data);
      setDetails(productCode);
      setRendering(false);
    }
    // console.log("Edit mode", editMode);
  }, [editMode, rendering]);

  const setDetails = async (code) => {
    try {
      const body = { products: [code] };
      const response = await fetchProductDetails(body);
      setSelectGradeType(response[0].grade);
      setReferenceCodes(response[0]?.reference_codes);
      let data = response[0];
      data.units["perWeight"] = "Per " + data.units.per_weight_unit;
      setProduct(data);
    } catch (err) {
      console.log(err);
    }
  };

  const deleteProductRecord = (code) => {
    deleteProduct(code)
      .then((response) => {
        // console.log('im', response);
        const res = {
          error: response.error,
          code: code,
          msg: response.msg,
        };
        routeBack("delete", res);
        // setSuccess(true);
        // setTimeout(() => {
        //   setSuccess(false);
        // }, 3000);
      })
      .catch((error) => {
        // setActionToaster({
        //   error: error.response.data.error,
        //   msg: error.response.data.msg,
        // });
        // showToaster();
        if(error?.response?.status == 500){
          setActionToaster({
            error: true,
            msg: "Something went wrong. Please try again",
          });
        } else{
          setActionToaster({
            error: true,
            msg: error?.response?.data?.msg,
          });      
        }
        showToaster();
        });
    // getOrdersList([650])
    //   .then((res) => console.log(res))
    //   .catch((error) => console.log(error));
  };

  const saveProductHandler = () => {
    form.submit();
  };

  const onFinish = async (values) => {
    if (!productTypes || selectedRange.length === 0) {
      setActionToaster({
        error: true,
        msg: "Please select both Product Type and Ply Range.",
      });
      showToaster();
      return;
    }
    let productName = capital_letter(values.name.trim());
    const cleanedReferenceCodes = referenceCodes
    .map(code => code.trim()) // remove extra spaces
    .filter(code => code !== "");
    let prouctValues = {
      ...product,
      code: values.code,
      // name: values.name.charAt(0).toUpperCase() + values.name.slice(1),
      name: productName,
      gsm: values.gsm,
      grade: values.grade,
      quality: values.quality,
      price: values.price,
      status: values.status,
      remarks: values.remarks,
      bulk: parseFloat(values.bulk).toFixed(3),
      ply: selectedRange.map(Number),
      type: productTypes,
    };
    let body = {
      code: values.code,
      // name: values.name.charAt(0).toUpperCase() + values.name.slice(1),
      name: productName,
      gsm: values.gsm,
      grade: values.grade,
      quality: values.quality,
      price: values.price,
      status: values.status,
      remarks: values.remarks,
      bulk: parseFloat(values.bulk).toFixed(2),
      units: { price: values.currency, per_weight_unit: values.weight },
      ply: selectedRange.map(Number),
      type: productTypes,
      reference_codes: cleanedReferenceCodes
    };

    if (values.burst_factor) {
      body["burst_factor"] = parseFloat(values.burst_factor).toFixed(2);
      prouctValues["burst_factor"] = parseFloat(values.burst_factor).toFixed(2);
    }

    if (values.moisture) {
      body["moisture"] = parseFloat(values.moisture).toFixed(2);
      prouctValues["moisture"] = parseFloat(values.moisture).toFixed(2);
    }

    setProduct(prouctValues);
    // console.log("values:", body);
    try {
      const editResponse = await editProduct(productCode, body);
      if (!editResponse.error) {
        setActionToaster({
          error: false,
          msg: `Product updated successfully`,
        });
        showToaster();
        setTimeout(() => {
          routeBack();
        }, 3000);
      }
    } catch (error) {
      // setActionToaster({
      //   error: error.response.data.error,
      //   msg: error.response.data.msg,
      // });
      // showToaster();

      if(error?.response?.status == 500){
          setActionToaster({
            error: true,
            msg: "Something went wrong. Please try again",
          });
      } else{
          setActionToaster({
            error: true,
            msg: error?.response?.data?.msg,
          });      
      }
      showToaster();
    }
  };

  const onChangeHandlerGradeBox = (value) => {
    form.setFieldsValue({ quality: null });
    setSelectGradeType(value);
  };

  // const modalShow = () => {
  //   setIsVisibleModal(true);
  // };

  // const modalClose = () => {
  //   setIsVisibleModal(false);
  // };

  // const modalConfirm = () => {
  //   setIsVisibleModal(false);
  // };

  const modalShowDelete = () => {
    setViewDelete(true);
  };

  const modalCancelDelete = () => {
    setViewDelete(false);
  };

  const modalConfirmDelete = (code) => {
    deleteProductRecord(code);
    setViewDelete(false);
  };

  const handleStatusChange = (e) => {
    //console.log('radio checked', e.target.value);
    setUserStatus(e.target.value);
  };

  const handleTabChange = () => {};

  const addNewSizeClick = () => {
    setSelectedStockSize();
    setSelectedStockSizeRow();
    setIsAddNewStockClicked(true);
    setIsEditStockClicked(false);
    setIsViewStockClicked(false);
    setNewStockSizeDrawer(true);
    setSelectedStockSize();
  };

  const onCloseAddNewStock = () => {
    setIsAddNewStockClicked(false);
    setIsEditStockClicked(false);
    setIsViewStockClicked(false);
    setNewStockSizeDrawer(false);
    setSelectedStockSize();
  };

  const searchStockSizes = async (value = "") => {
    setSearchValue(value);
    if (value === "" || value === null) {
      setRendering(true);
    } else {
      setClearSearch(false);
      searchProductStock(productCode, value)
        .then((response) => {
          const stockSearch = response.map((item) => {
            return {
              type: capitalize(item.type),
              size:
                item.type === "reel"
                  ? +item.width + " CM"
                  : +item.width + " * " + +item.length + " CM",
              maxAllowedStock: item.quantity + " TONNE",
              stockInSystem:
                (item.in_process + item.in_production + item.completed).toFixed(
                  3
                ) + " TONNE",
              availableLimit:
                (
                  item.quantity -
                  (item.in_process + item.in_production + item.completed)
                ).toFixed(3) < 0
                  ? 0 + " T"
                  : (
                      item.quantity -
                      (item.in_process + item.in_production + item.completed)
                    ).toFixed(3) + " TONNE",
              status: capitalize(item.status),
            };
          });
          setStockSizesList(stockSearch);
          setRendering(false);
        })
        .catch((error) => console.log("Error in searching stocks:", error));
    }
  };

  const exportHandler = () => {};

  const showToaster = () => {
    setVisibleToaster(true);
    setTimeout(() => setVisibleToaster(false), 2000);
  };

  const onViewChangeHistory = () => {
    navigate("../history", {
      state: {
        product: {
          productCode: productCode,
          action: location.state.action,
          route: "../edit-products-records",
          roles: roles,
        },
        logType: "Product",
        name: product.name,
        searchText: "Search change in product property",
      },
    });
  };

const handleAddReferenceCode = () => {
    setReferenceCodes([...referenceCodes, ""]);
  };

  const handleReferenceCodeChange = (value, index) => {
    const updated = [...referenceCodes];
    updated[index] = value;
    setReferenceCodes(updated);

    form.setFieldsValue({[`ref_code${index}`]: value,});
  };

  const handleDeleteReferenceCode = (index) => {
    // const updated = referenceCodes.filter((_, i) => i !== index);
    // setReferenceCodes(updated);

    const updated = referenceCodes.filter((_, i) => i !== index);
    setReferenceCodes(updated);

    const currentValues = form.getFieldsValue();
    const newValues = {};

     if(updated?.length == 0){
      Object.keys(currentValues).forEach((key) => {
        if (key.startsWith("ref_code")) {
          newValues[key] = undefined;
        }
      });
    } else{
        updated.forEach((item, i) => {
        newValues[`ref_code${i}`] = item;
      });
    }

    form.setFieldsValue(newValues);
  };

  useEffect(() => {
    if (product) {
      // setProductTypes(product.type);
      // setSelectedRange(product.ply.map(String)); // <--- convert to string

      const plyValues = product.ply.map(String);

    setProductTypes(product.type);
    setSelectedRange(plyValues);

    form.setFieldsValue({
      ply_range: plyValues, // ✅ THIS FIXES YOUR ISSUE
    });

    }
  }, [product]);

  return product && unitData ? (
    <RightLayoutContainer>
      <PageTitleComp className="marginRightAdg" style={{ borderBottom: "0" }}>
        <PageHeader
          ghost={false}
          onBack={!editMode && (() => navigate("../products-records"))}
          title={product.name}
          extra={
            editMode
              ? [
                  <Button key="4" className="textTypeBtn" onClick={modalShow}>
                    Cancel changes
                  </Button>,
                  <Button
                    key="5"
                    className="themeBtn"
                    onClick={saveProductHandler}
                  >
                    <Iconmoon icon="addcircle" size={14} color="#ffffff" />
                    Save Product
                  </Button>,
                ]
              : userDetails.roles.product_records.edit
              ? [
                  <Button
                    key="1"
                    className="themeBtn noBg"
                    onClick={onViewChangeHistory}
                  >
                    <Iconmoon
                      icon="order-entry-icon"
                      size={14}
                      color="#EA655B"
                    />
                    View Change History
                  </Button>,
                  <Button
                    key="2"
                    className="themeBtn noBg"
                    onClick={modalShowDelete}
                    disabled={!roles.edit}
                  >
                    <Iconmoon icon="delete" size={14} color="#EA655B" />
                    Delete Product
                  </Button>,
                ]
              : [
                  <Button
                    key="1"
                    className="themeBtn noBg"
                    onClick={onViewChangeHistory}
                  >
                    <Iconmoon
                      icon="order-entry-icon"
                      size={14}
                      color="#EA655B"
                    />
                    View Change History
                  </Button>,
                ]
          }
        ></PageHeader>
      </PageTitleComp>
      {!editMode ? (
        <div className="groupedTabed">
          <StyledTab>
            <Tabs defaultActiveKey="1" onChange={handleTabChange}>
              <Panes tab="Basic Details" key="1">
                <div className="flx-end">
                  <Button
                    key="3"
                    className="themeBtn"
                    onClick={() => setEditMode(true)}
                    disabled={!roles.edit}
                  >
                    <Iconmoon icon="edit" size={14} color="#ffffff" />
                    Edit Product
                  </Button>
                </div>
                <DetailFields>
                  <HaberForm>
                    <div className="groupDetailWrap">
                      <Form
                        form={form}
                        name="basic"
                        autoComplete="off"
                        className="haberLogin"
                        onFinish={onFinish}
                      >
                        <Row gutter={[16, 16]} className="groupForm">
                          <Col span={8}>
                            <GroupTitle>
                              <h2>General Details</h2>
                              <p>
                                The general details of the product will be used
                                in reports and order records
                              </p>
                            </GroupTitle>
                          </Col>
                          <Col span={16}>
                            <Row className="centerAlign">
                              <Col span={12}>
                                <div className="boxFieldTitle">
                                  <label>Product Code</label>
                                  <p>This is an auto generated code</p>
                                </div>
                              </Col>
                              <Col span={12}>
                                <div className="boxFormType">
                                  <Form.Item
                                    name="code"
                                    rules={[{ required: true }]}
                                    className=""
                                    initialValue={product.code}
                                  >
                                    <Input disabled={true} />
                                  </Form.Item>
                                </div>
                              </Col>
                            </Row>
                            <Row className="centerAlign">
                              <Col span={12}>
                                <div className="boxFieldTitle">
                                  <label>Product Name</label>
                                  <p>
                                    The product will be identified by this
                                    unique name
                                  </p>
                                </div>
                              </Col>
                              <Col span={12}>
                                <div className="boxFormType">
                                  <Form.Item
                                    name="name"
                                    rules={[
                                      {
                                        required: true,
                                        message: "This field is required",
                                      },
                                      {
                                        max: 50,
                                        message:
                                          "Name can have a maximum of 50 characters",
                                      },
                                    ]}
                                    className=""
                                    initialValue={product.name}
                                  >
                                    <Input
                                      disabled={!editMode}
                                      placeholder="Enter name of the Product"
                                      style={{ textTransform: "capitalize" }}
                                    />
                                  </Form.Item>
                                </div>
                              </Col>
                            </Row>
                            <Row className="centerAlign">
                              <Col span={12}>
                                <div className="boxFieldTitle">
                                  <label>Product Reference Codes <span>(Optional)</span></label>
                                  <p>The product can have multiple reference codes</p>
                                </div>
                              </Col>

                              <Col span={12}>
                                <div className="boxFormType" style={{ display: "flex", gap: 8 }}>
                                  <Input
                                    value={
                                      referenceCodes?.length
                                        ? referenceCodes.slice(0, 3).join(", ")
                                        : ""
                                    }
                                    disabled
                                  />
                                  {referenceCodes?.length > 3 && (
                                    <Tooltip
                                      placement="bottomRight"
                                      title={
                                        referenceCodes
                                          .slice(3)
                                          .map((code, i) => `Code ${i + 4}: ${code}`)
                                          .join("\n")
                                      }
                                      className="edit-tooltip"
                                      getPopupContainer={(triggerNode) => triggerNode}
                                    >
                                      <span className="infoIcon" style={{ cursor: "pointer", marginTop: "11px" }} />
                                    </Tooltip>
                                  )}
                                  
                                </div>
                              </Col>

                              {/* <Col span={12}>
                                <div className="boxFormType">
                                  {referenceCodes.map((code, index) => (
                                    <Row
                                      key={index}
                                      gutter={8}
                                      align="middle"
                                      style={{ marginBottom: 8 }}
                                    >
                                      <Col flex="auto">
                                        <Input
                                          placeholder="Enter reference code"
                                          value={code}
                                          maxLength={30}
                                          onChange={(e) =>
                                            handleReferenceCodeChange(e.target.value, index)
                                          }
                                        />
                                      </Col>

                                      <Col>
                                        <Button
                                          type="text"
                                          danger
                                          onClick={() => handleDeleteReferenceCode(index)}
                                          icon={<Iconmoon icon="delete" size={16} />}
                                        />
                                      </Col>
                                    </Row>
                                  ))}

                                  <Row justify="end">
                                    <Button
                                      className="themeBtn noBg"
                                      onClick={handleAddReferenceCode}
                                    >
                                      <Iconmoon icon="addcircle" size={16} color="#EA655B" />{" "}
                                      Add
                                    </Button>
                                  </Row>

                                </div>
                              </Col> */}
                            </Row>
                          </Col>
                        </Row>
                        <Row gutter={[16, 16]} className="groupForm">
                          <Col span={8}>
                            <GroupTitle>
                              <h2>Product Specifications</h2>
                              <p>
                                The product specification will be used to
                                identify a product and will be used in deckle
                                matching process
                              </p>
                            </GroupTitle>
                          </Col>
                          <Col span={16} className="blockBreak">
                            <Row className="centerAlign">
                              <Col span={12}>
                                <div className="boxFieldTitle">
                                  <label>Grade</label>
                                  <p>Grade of the Product</p>
                                </div>
                              </Col>
                              <Col span={12}>
                                <div className="boxFormType">
                                  <Form.Item
                                    name="grade"
                                    rules={[
                                      {
                                        required: true,
                                        message: "Please select a grade",
                                      },
                                    ]}
                                    initialValue={product.grade}
                                  >
                                    <Select
                                      suffixIcon={
                                        isGradeDropdownOpen ? (
                                          <DropDownSearchDraw />
                                        ) : (
                                          <DownArrowDraw />
                                        )
                                      }
                                      onBlur={OnGradetoggleSelect}
                                      onFocus={OnGradetoggleSelect}
                                      showSearch
                                      optionFilterProp="children"
                                      filterOption={(input, option) =>
                                        option.children
                                          .toLowerCase()
                                          .includes(input.toLowerCase())
                                      }
                                      defaultValue={"Select a grade"}
                                      onChange={onChangeHandlerGradeBox}
                                      value={product.grade}
                                      disabled={!editMode}
                                    >
                                      {grades.map((gradeType) => (
                                        <Option key={gradeType}>
                                          {gradeType}
                                        </Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                </div>
                              </Col>
                            </Row>
                            <Row className="centerAlign">
                              <Col span={12}>
                                <div className="boxFieldTitle">
                                  <label>GSM</label>
                                  <p>GSM of the product</p>
                                </div>
                              </Col>
                              <Col span={12}>
                                <div className="boxFormType">
                                  <Form.Item
                                    name="gsm"
                                    className=""
                                    rules={[
                                      {
                                        required: true,
                                        message: "This field is required",
                                      },
                                      {
                                        pattern: /^(0|[1-9]\d*)(\.\d+)?$/,
                                        message:
                                          "Only numeric characters are allowed",
                                      },
                                      {
                                        max: 4,
                                        message:
                                          "GSM cannot be more than four characters",
                                      },
                                    ]}
                                    initialValue={`${product.gsm}`}
                                  >
                                    <Input
                                      placeholder="Enter GSM of the product"
                                      disabled={!editMode}
                                    />
                                  </Form.Item>
                                </div>
                              </Col>
                            </Row>
                            {productParam?.product?.burst_factor && (
                              <Row className="centerAlign">
                                <Col span={12}>
                                  <div className="boxFieldTitle">
                                    <label>Burst Factor</label>
                                    <p>Burst factor of the product</p>
                                  </div>
                                </Col>
                                <Col span={12}>
                                  <div className="boxFormType">
                                    <Form.Item
                                      name="burst_factor"
                                      className=""
                                      rules={[
                                        {
                                          required: true,
                                          message: "This field is required",
                                        },
                                        {
                                          pattern: /^(0|[1-9]\d*)(\.\d+)?$/,
                                          message:
                                            "Only numeric characters are allowed",
                                        },
                                      ]}
                                      initialValue={product.burst_factor}
                                    >
                                      <Input
                                        placeholder="Enter Burst Factor of the product"
                                        disabled={!editMode}
                                      />
                                    </Form.Item>
                                  </div>
                                </Col>
                              </Row>
                            )}
                            {productParam && !productParam.product && (
                              <Row className="centerAlign">
                                <Col span={12}>
                                  <div className="boxFieldTitle">
                                    <label>Burst Factor</label>
                                    <p>Burst factor of the product</p>
                                  </div>
                                </Col>
                                <Col span={12}>
                                  <div className="boxFormType">
                                    <Form.Item
                                      name="burst_factor"
                                      className=""
                                      rules={[
                                        {
                                          required: true,
                                          message: "This field is required",
                                        },
                                        {
                                          pattern: /^(0|[1-9]\d*)(\.\d+)?$/,
                                          message:
                                            "Only numeric characters are allowed",
                                        },
                                      ]}
                                      initialValue={product.burst_factor}
                                    >
                                      <Input
                                        placeholder="Enter Burst Factor of the product"
                                        disabled={!editMode}
                                      />
                                    </Form.Item>
                                  </div>
                                </Col>
                              </Row>
                            )}
                            <Row className="centerAlign">
                              <Col span={12}>
                                <div className="boxFieldTitle">
                                  <label>Bulk</label>
                                  <p>Bulk of the product</p>
                                </div>
                              </Col>
                              <Col span={12}>
                                <div className="boxFormType">
                                  <Form.Item
                                    name="bulk"
                                    rules={[
                                      {
                                        required: true,
                                        message: "This field is required",
                                      },
                                      {
                                        pattern: /^(0|[1-9]\d*)(\.\d+)?$/,
                                        message:
                                          "Only numeric characters are allowed",
                                      },
                                    ]}
                                    className=""
                                    initialValue={product.bulk}
                                  >
                                    <Input
                                      placeholder="Enter bulk of the product"
                                      disabled={!editMode}
                                    />
                                  </Form.Item>
                                  <span className="nonEditable">c.c./gm</span>
                                </div>
                              </Col>
                            </Row>
                            {productParam?.product?.moisture && (
                              <Row className="centerAlign">
                                <Col span={12}>
                                  <div className="boxFieldTitle">
                                    <label>Moisture</label>
                                    <p>Moisture of the product</p>
                                  </div>
                                </Col>
                                <Col span={12}>
                                  <div className="boxFormType">
                                    <Form.Item
                                      name="moisture"
                                      rules={[
                                        {
                                          required: true,
                                          message: "This field is required",
                                        },
                                        {
                                          pattern: /^(0|[1-9]\d*)(\.\d+)?$/,
                                          message:
                                            "Only numeric characters are allowed",
                                        },
                                      ]}
                                      className=""
                                      initialValue={product.moisture}
                                    >
                                      <Input
                                        placeholder="Enter moisture of the product"
                                        disabled={!editMode}
                                      />
                                    </Form.Item>
                                  </div>
                                </Col>
                              </Row>
                            )}
                            <Row className="centerAlign">
                              <Col span={12}>
                                <div className="boxFieldTitle">
                                  <label>Quality</label>
                                  <p>Quality of the product</p>
                                </div>
                              </Col>
                              <Col span={12}>
                                <div className="boxFormType">
                                  {/* The list of qualities will be fetched from configuration global settings */}
                                  <Form.Item
                                    name="quality"
                                    initialValue={product.quality}
                                    rules={[
                                      {
                                        required:
                                          true && qualities.length !== 0,
                                        message: "Please select a quality",
                                      },
                                    ]}
                                  >
                                    <Select
                                      suffixIcon={
                                        isQualityDropdownOpen ? (
                                          <DropDownSearchDraw />
                                        ) : (
                                          <DownArrowDraw />
                                        )
                                      }
                                      onBlur={OntoggleSelect}
                                      onFocus={OntoggleSelect}
                                      showSearch
                                      optionFilterProp="children"
                                      filterOption={(input, option) =>
                                        option.children
                                          .toLowerCase()
                                          .includes(input.toLowerCase())
                                      }
                                      defaultValue={"Select a grade"}
                                      disabled={!editMode || !selectGradeType}
                                      value={product.quality}
                                      //disabled={!editMode}
                                    >
                                      {qualities.map((qualityType) => (
                                        <Option key={qualityType}>
                                          {qualityType}
                                        </Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                </div>
                              </Col>
                            </Row>
                            <Row className="centerAlign">
                              <Col span={12}>
                                <div className="boxFieldTitle">
                                  <label>Price</label>
                                  <p>Price of the product per weight</p>
                                </div>
                              </Col>
                              <Col span={12}>
                                <Row className="centerAlign ">
                                  <Col span={24} className="d-flex threeFields">
                                    <div
                                      className="boxFormType unitSelect"
                                      style={{ marginBottom: "0" }}
                                    >
                                      <Form.Item
                                        name="currency"
                                        initialValue={product.units.price}
                                      >
                                        <Select
                                          placeholder="Unit"
                                          suffixIcon={<DownArrowDraw />}
                                          disabled={!editMode}
                                          showSearch
                                        >
                                          {unitData.units_management.currency.currencyList.map(
                                            (currency) => (
                                              <Option key={currency.code}>
                                                <Tooltip
                                                  title={currency.displayName}
                                                >
                                                  {`${currency.code}`}
                                                </Tooltip>
                                              </Option>
                                            )
                                          )}
                                        </Select>
                                      </Form.Item>
                                    </div>
                                    <div
                                      className="boxFormType"
                                      style={{ marginBottom: "0" }}
                                    >
                                      <Form.Item
                                        name="price"
                                        rules={[
                                          {
                                            required: true,
                                            message: "This field is required",
                                          },
                                          {
                                            pattern: /^\d+(\.\d{1,3})?$|^\.\d{1,3}$/,
                                            message:
                                              "Only decimal characters upto 3 decimal places are allowed",
                                          },
                                        ]}
                                        className=""
                                        initialValue={product.price}
                                      >
                                        <Input
                                          placeholder="Enter price of product"
                                          disabled={!editMode}
                                        />
                                      </Form.Item>
                                    </div>
                                    <div
                                      className="boxFormType "
                                      style={{ marginBottom: "0" }}
                                    >
                                      <Form.Item
                                        name="weight"
                                        initialValue={
                                          product.units.per_weight_unit
                                        }
                                      >
                                        <Select
                                          placeholder="Unit"
                                          suffixIcon={<DownArrowDraw />}
                                          showSearch
                                          disabled={!editMode}
                                        >
                                          {unitData.units_management.weight.perWeight.map(
                                            (weight) => (
                                              <Option key={weight.value}>
                                                {`${weight.label}`}
                                              </Option>
                                            )
                                          )}
                                        </Select>
                                      </Form.Item>
                                    </div>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                            <Row className="centerAlign">
                              <Col span={12}>
                                <div className="boxFieldTitle">
                                  <label>Product type</label>
                                  <p>
                                    The product can be of reel or sheet type
                                  </p>
                                </div>
                              </Col>
                              <Col span={12}>
                                <div className="boxFormType">
                                  <Form.Item
                                    name="type"
                                    rules={[
                                      {
                                        required: true,
                                        message: "This field is required",
                                      },
                                    ]}
                                    className="selectForm"
                                    initialValue={product.type}
                                  >
                                    <Select
                                      placeholder="Select"
                                      suffixIcon={<DownArrowDraw />}
                                      onChange={(value) =>
                                        setProductTypes(value)
                                      }
                                      disabled={!editMode}
                                    >
                                      {types.map((orderType) => (
                                        <Option key={orderType.value}>
                                          {orderType.label}
                                        </Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                </div>
                              </Col>
                            </Row>
                            <Row className="centerAlign">
                              <Col span={12}>
                                <div className="boxFieldTitle">
                                  <label>Ply Range</label>
                                  <p>
                                    Ply count that can be processed by this
                                    product
                                  </p>
                                </div>
                              </Col>
                              <Col span={12}>
                                <div className="boxFormType">
                                  <Form.Item
                                    name="ply_range"
                                    rules={[
                                      {
                                        validator: () =>{
                                          if(!switchFetchOrdersfromERP && !selectedRange.length)
                                          {
                                            return Promise.reject("This field is required!")
                                          }
                                          return Promise.resolve();
                                        }
                                      }
                                    ]}
                                    className="selectForm"
                                    initialValue={
                                      selectedRange.length
                                        ? selectedRange[0]
                                        : null
                                    }
                                  >
                                    <div class="checkboxFilt">
                                      {productTypes === "reel" ||
                                      productTypes === "both" ? (
                                        <Checkbox.Group
                                          value={selectedRange}
                                          onChange={handleCheckboxChange}
                                          style={{ width: "100%" }}
                                          // disabled={action === "view"}
                                          disabled={!editMode}
                                        >
                                          <Row gutter={16}>{checkboxes}</Row>
                                        </Checkbox.Group>
                                      ) : (
                                        <Checkbox
                                          value={1}
                                          disabled={!editMode}
                                        >
                                          {" "}
                                          <span
                                            style={{
                                              color: "#323130",
                                              fontSize: "14px",
                                              fontFamily:
                                                "font-family: var(--sf-pro-text)",
                                              fontStyle: "normal",
                                            }}
                                          >
                                            {1}
                                          </span>
                                        </Checkbox>
                                      )}
                                    </div>
                                  </Form.Item>
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </Row>

                        <Row gutter={[16, 16]}>
                          <Col span={8}>
                            <GroupTitle>
                              <h2>Other Information</h2>
                              <p>
                                All Other information related to this product
                              </p>
                            </GroupTitle>
                          </Col>
                          <Col span={16}>
                            <Row className="centerAlign">
                              <Col span={12}>
                                <div className="boxFieldTitle">
                                  <label>Status</label>
                                  <p>
                                    The order for this product will only be
                                    recorded if it's enabled
                                  </p>
                                </div>
                              </Col>
                              <Col span={12}>
                                <div
                                  className="boxFormType switchRadio"
                                  style={{
                                    justifyContent: "flex-end",
                                    display: "flex",
                                  }}
                                >
                                  <Form.Item
                                    name="status"
                                    initialValue={product.status}
                                  >
                                    <Radio.Group
                                      options={userStatusData}
                                      onChange={handleStatusChange}
                                      value={userStatus}
                                      optionType="button"
                                      buttonStyle="solid"
                                      disabled={!editMode}
                                    />
                                  </Form.Item>
                                </div>
                              </Col>
                            </Row>
                            <Row className="centerAlign">
                              <Col span={12}>
                                <div className="boxFieldTitle">
                                  <label>
                                    Remarks <span>(Optional)</span>
                                  </label>
                                  <p>Extra information of this product</p>
                                </div>
                              </Col>
                              <Col span={12}>
                                <div className="boxFormType">
                                  <GlobalSet>
                                    <Form.Item
                                      name="remarks"
                                      rules={[
                                        {
                                          max: 70,
                                          message:
                                            "Remarks can have a maximum of 70 characters",
                                        },
                                      ]}
                                      className=""
                                      initialValue={product.remarks}
                                    >
                                      <TextArea
                                        maxLength={100}
                                        style={{ height: 90 }}
                                        disabled={!editMode}
                                      />
                                    </Form.Item>
                                  </GlobalSet>
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Form>
                    </div>
                  </HaberForm>
                </DetailFields>
              </Panes>
              <Panes tab="Stock Sizes" key="2">
                {/* <DetailFields>
        <div className="flx-end">
                  <Button
                    key="2"
                    className="themeBtn noBg"
                    onClick={addNewSizeClick}
                    // disabled={!userDetails.roles.production.jumbo_reels.edit}
                  >
                    <Iconmoon icon="edit" size={14} color="#EA655B" />
                    Add a New Size
                  </Button>
                </div>
        </DetailFields> */}
                <TableLayoutData>
                  <div className="tableDataFormat">
                    <SearchContainer
                      placeholder={"Search size"}
                      fetchOrder={searchStockSizes}
                      productRecordRole={userDetails.roles.product_records.edit}
                      addNewSizeClick={addNewSizeClick}
                      clearSearch={clearSearch}
                      setClearSearch={setClearSearch}
                      searchedValue={searchValue}
                      hideExport={true}
                    />
                    <Table
                      columns={columnsHead}
                      dataSource={stockSizesList}
                      scroll={{ x: window.screen.width < 1500 && 1027 }}
                      onChange={onChange}
                      pagination={{
                        current: currentPage,
                        total: stockSizesList.length,
                        showTitle: false,
                        showTotal: (total, range) =>
                          `Showing ${range[0]}-${range[1]} of ${total} results`,
                        pageSizeOptions: [10, 20, 50, 100],
                        showSizeChanger: true,
                      }}
                    />
                  </div>
                </TableLayoutData>
              </Panes>
            </Tabs>
          </StyledTab>
        </div>
      ) : (
        <DetailFields>
          <HaberForm>
            <div className="groupDetailWrap">
              <Form
                form={form}
                name="basic"
                autoComplete="off"
                className="haberLogin"
                onFinish={onFinish}
              >
                <Row gutter={[16, 16]} className="groupForm">
                  <Col span={8}>
                    <GroupTitle>
                      <h2>General Details</h2>
                      <p>
                        The general details of the product will be used in
                        reports and order records
                      </p>
                    </GroupTitle>
                  </Col>
                  <Col span={16}>
                    <Row className="centerAlign">
                      <Col span={12}>
                        <div className="boxFieldTitle">
                          <label>Product Code</label>
                          <p>This is an auto generated code</p>
                        </div>
                      </Col>
                      <Col span={12}>
                        <div className="boxFormType">
                          <Form.Item
                            name="code"
                            rules={[{ required: true }]}
                            className=""
                            initialValue={product.code}
                          >
                            <Input disabled={true} />
                          </Form.Item>
                        </div>
                      </Col>
                    </Row>
                    <Row className="centerAlign">
                      <Col span={12}>
                        <div className="boxFieldTitle">
                          <label>Product Name</label>
                          <p>
                            The product will be identified by this unique name
                          </p>
                        </div>
                      </Col>
                      <Col span={12}>
                        <div className="boxFormType">
                          <Form.Item
                            name="name"
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                              {
                                max: 50,
                                message:
                                  "Name can have a maximum of 50 characters",
                              },
                              {
                                validator(_, value) {
                                  if (product) {
                                    if (value === product.name)
                                      return Promise.resolve();
                                  }
                                  if (
                                    value == null ||
                                    !products.filter(
                                      (data) =>
                                        data.name.toUpperCase() ===
                                        value.toUpperCase()
                                    ).length
                                  ) {
                                    return Promise.resolve();
                                  } else {
                                    return Promise.reject(
                                      "This name exists for another product"
                                    );
                                  }
                                },
                              },
                            ]}
                            className=""
                            initialValue={product.name}
                          >
                            <Input
                              disabled={!editMode}
                              placeholder="Enter name of the Product"
                              style={{ textTransform: "capitalize" }}
                            />
                          </Form.Item>
                        </div>
                      </Col>
                    </Row>
                     <Row className="centerAlign">
                              <Col span={12}>
                                <div className="boxFieldTitle">
                                  <label>Product Reference Codes <span>(Optional)</span></label>
                                  <p>The product can have multiple reference codes</p>
                                </div>
                              </Col>

                              <Col span={12}>
                                <div className="boxFormType">

                                  {/* Render Existing Codes */}
                                  {referenceCodes?.map((code, index) => (
                                    <Row
                                      key={index+1}
                                      gutter={8}
                                      align="middle"
                                      style={{ marginBottom: 8 }}
                                    >
                                      <Col flex="auto">
                                      <Form.Item
                                          name={`ref_code${index}`}
                                          rules={[
                                                {
                                                pattern: /^[a-zA-Z0-9 ]+$/,
                                                message: "Reference Code can be only alphanumeric!",
                                              },
                                            ]}
                                          className=""
                                          initialValue={code}
                                        >
                                        <Input
                                          placeholder="Enter reference code"
                                          value={code}
                                          rules={[
                                            {
                                              pattern: /^[a-zA-Z0-9 ]+$/,
                                              message: "Reference Code can be only alphanumeric!",
                                            },
                                          ]}
                                          maxLength={30}
                                          onChange={(e) =>
                                            handleReferenceCodeChange(e.target.value, index)
                                          }
                                        />
                                      </Form.Item>
                                      </Col>

                                      <Col>
                                        <Button
                                          type="text"
                                          danger
                                          onClick={() => handleDeleteReferenceCode(index)}
                                          icon={<Iconmoon icon="delete" size={16} />}
                                        />
                                      </Col>
                                    </Row>
                                  ))}

                                  <Row justify="end">
                                    <Button
                                      className="themeBtn noBg"
                                      onClick={handleAddReferenceCode}
                                    >
                                      <Iconmoon icon="addcircle" size={16} color="#EA655B" />{" "}
                                      Add
                                    </Button>
                                  </Row>

                                </div>
                              </Col>
                            </Row>
                  </Col>
                </Row>
                <Row gutter={[16, 16]} className="groupForm">
                  <Col span={8}>
                    <GroupTitle>
                      <h2>Product Specifications</h2>
                      <p>
                        The product specification will be used to identify a
                        product and will be used in deckle matching process
                      </p>
                    </GroupTitle>
                  </Col>
                  <Col span={16} className="blockBreak">
                    <Row className="centerAlign">
                      <Col span={12}>
                        <div className="boxFieldTitle">
                          <label>Grade</label>
                          <p>Grade of the Product</p>
                        </div>
                      </Col>
                      <Col span={12}>
                        <div className="boxFormType">
                          <Form.Item
                            name="grade"
                            rules={[
                              {
                                required: true,
                                message: "Please select a grade",
                              },
                            ]}
                            initialValue={product.grade}
                          >
                            <Select
                              suffixIcon={
                                isGradeDropdownOpen ? (
                                  <DropDownSearchDraw />
                                ) : (
                                  <DownArrowDraw />
                                )
                              }
                              onBlur={OnGradetoggleSelect}
                              onFocus={OnGradetoggleSelect}
                              showSearch
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              defaultValue={"Select a grade"}
                              onChange={onChangeHandlerGradeBox}
                              value={product.grade}
                              disabled={!editMode || product.order_exists}
                            >
                              {grades.map((gradeType) => (
                                <Option key={gradeType}>{gradeType}</Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </div>
                      </Col>
                    </Row>
                    <Row className="centerAlign">
                      <Col span={12}>
                        <div className="boxFieldTitle">
                          <label>GSM</label>
                          <p>GSM of the product</p>
                        </div>
                      </Col>
                      <Col span={12}>
                        <div className="boxFormType">
                          <Form.Item
                            name="gsm"
                            className=""
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                              {
                                pattern: /^(0|[1-9]\d*)(\.\d+)?$/,
                                message: "Only numeric characters are allowed",
                              },
                              {
                                max: 4,
                                message:
                                  "GSM cannot be more than four characters",
                              },
                            ]}
                            initialValue={`${product.gsm}`}
                          >
                            <Input
                              placeholder="Enter GSM of the product"
                              disabled={!editMode || product.order_exists}
                            />
                          </Form.Item>
                        </div>
                      </Col>
                    </Row>
                    {productParam?.product?.burst_factor && (
                      <Row className="centerAlign">
                        <Col span={12}>
                          <div className="boxFieldTitle">
                            <label>Burst Factor</label>
                            <p>Burst factor of the product</p>
                          </div>
                        </Col>
                        <Col span={12}>
                          <div className="boxFormType">
                            <Form.Item
                              name="burst_factor"
                              className=""
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required",
                                },
                                {
                                  pattern: /^(0|[1-9]\d*)(\.\d+)?$/,
                                  message:
                                    "Only numeric characters are allowed",
                                },
                              ]}
                              initialValue={
                                product.burst_factor
                                  ? product.burst_factor
                                  : undefined
                              }
                            >
                              <Input
                                placeholder="Enter Burst Factor of the product"
                                disabled={!editMode || product.order_exists}
                              />
                            </Form.Item>
                          </div>
                        </Col>
                      </Row>
                    )}
                    {productParam && !productParam.product && (
                      <Row className="centerAlign">
                        <Col span={12}>
                          <div className="boxFieldTitle">
                            <label>Burst Factor</label>
                            <p>Burst factor of the product</p>
                          </div>
                        </Col>
                        <Col span={12}>
                          <div className="boxFormType">
                            <Form.Item
                              name="burst_factor"
                              className=""
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required",
                                },
                                {
                                  pattern: /^(0|[1-9]\d*)(\.\d+)?$/,
                                  message:
                                    "Only numeric characters are allowed",
                                },
                              ]}
                              initialValue={product.burst_factor}
                            >
                              <Input
                                placeholder="Enter Burst Factor of the product"
                                disabled={!editMode || product.order_exists}
                              />
                            </Form.Item>
                          </div>
                        </Col>
                      </Row>
                    )}
                    <Row className="centerAlign">
                      <Col span={12}>
                        <div className="boxFieldTitle">
                          <label>Bulk</label>
                          <p>Bulk of the product</p>
                        </div>
                      </Col>
                      <Col span={12}>
                        <div className="boxFormType">
                          <Form.Item
                            name="bulk"
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                              {
                                pattern: /^(0|[1-9]\d*)(\.\d+)?$/,
                                message: "Only numeric characters are allowed",
                              },
                            ]}
                            className=""
                            initialValue={product.bulk}
                          >
                            <Input
                              placeholder="Enter bulk of the product"
                              disabled={!editMode}
                            />
                          </Form.Item>
                          <span className="nonEditable">c.c./gm</span>
                        </div>
                      </Col>
                    </Row>
                    {productParam?.product?.moisture && (
                      <Row className="centerAlign">
                        <Col span={12}>
                          <div className="boxFieldTitle">
                            <label>Moisture</label>
                            <p>Moisture of the product</p>
                          </div>
                        </Col>
                        <Col span={12}>
                          <div className="boxFormType">
                            <Form.Item
                              name="moisture"
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required",
                                },
                                {
                                  pattern: /^(0|[1-9]\d*)(\.\d+)?$/,
                                  message:
                                    "Only numeric characters are allowed",
                                },
                              ]}
                              className=""
                              initialValue={
                                product.moisture ? product.moisture : undefined
                              }
                            >
                              <Input
                                placeholder="Enter moisture of the product"
                                disabled={!editMode || product.order_exists}
                              />
                            </Form.Item>
                          </div>
                        </Col>
                      </Row>
                    )}
                    <Row className="centerAlign">
                      <Col span={12}>
                        <div className="boxFieldTitle">
                          <label>Quality</label>
                          <p>Quality of the product</p>
                        </div>
                      </Col>
                      <Col span={12}>
                        <div className="boxFormType">
                          {/* The list of qualities will be fetched from configuration global settings */}
                          <Form.Item
                            name="quality"
                            initialValue={product.quality}
                            rules={[
                              {
                                required: true && qualities.length !== 0,
                                message: "Please select a quality",
                              },
                            ]}
                          >
                            <Select
                              suffixIcon={
                                isQualityDropdownOpen ? (
                                  <DropDownSearchDraw />
                                ) : (
                                  <DownArrowDraw />
                                )
                              }
                              onBlur={OntoggleSelect}
                              onFocus={OntoggleSelect}
                              showSearch
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              defaultValue={"Select a grade"}
                              disabled={
                                !editMode ||
                                !selectGradeType ||
                                product.order_exists
                              }
                              value={product.quality}
                              //disabled={!editMode}
                            >
                              {qualities.map((qualityType) => (
                                <Option key={qualityType}>{qualityType}</Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </div>
                      </Col>
                    </Row>
                    <Row className="centerAlign">
                      <Col span={12}>
                        <div className="boxFieldTitle">
                          <label>Price</label>
                          <p>Price of the product</p>
                        </div>
                      </Col>
                      <Col span={12}>
                        <Row className="centerAlign ">
                          <Col span={24} className="d-flex threeFields">
                            <div
                              className="boxFormType unitSelect"
                              style={{ marginBottom: "0" }}
                            >
                              <Form.Item
                                name="currency"
                                initialValue={product.units.price}
                              >
                                <Select
                                  placeholder="Unit"
                                  suffixIcon={<DownArrowDraw />}
                                  showSearch
                                >
                                  {unitData?.units_management.currency.currencyList.map(
                                    (currency) => (
                                      <Option key={currency.code}>
                                        <Tooltip title={currency.displayName}>
                                          {`${currency.code}`}
                                        </Tooltip>
                                      </Option>
                                    )
                                  )}
                                </Select>
                              </Form.Item>
                            </div>
                            <div
                              className="boxFormType"
                              style={{ marginBottom: "0" }}
                            >
                              <Form.Item
                                name="price"
                                rules={[
                                  {
                                    required: true,
                                    message: "This field is required",
                                  },
                                  {
                                    pattern: /^\d+(\.\d{1,3})?$|^\.\d{1,3}$/,
                                    message:
                                      "Only decimal characters upto 3 decimal places are allowed",
                                  },
                                ]}
                                className=""
                                initialValue={product.price}
                              >
                                <Input placeholder="Enter price of product" />
                              </Form.Item>
                            </div>
                            <div
                              className="boxFormType "
                              style={{ marginBottom: "0" }}
                            >
                              <Form.Item
                                name="weight"
                                initialValue={product.units.per_weight_unit}
                              >
                                <Select
                                  placeholder="Unit"
                                  suffixIcon={<DownArrowDraw />}
                                  showSearch
                                  disabled={!editMode}
                                >
                                  {unitData.units_management.weight.perWeight.map(
                                    (weight) => (
                                      <Option key={weight.value}>
                                        {`${weight.label}`}
                                      </Option>
                                    )
                                  )}
                                </Select>
                              </Form.Item>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row className="centerAlign">
                      <Col span={12}>
                        <div className="boxFieldTitle">
                          <label>Product type</label>
                          <p>The product can be of reel or sheet type</p>
                        </div>
                      </Col>
                      <Col span={12}>
                        <div className="boxFormType">
                          <Form.Item
                            name="type"
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                            ]}
                            className="selectForm"
                            initialValue={product.type}
                          >
                            <Select
                              placeholder="Select"
                              suffixIcon={<DownArrowDraw />}
                              onChange={handleProductTypeChange}
                              disabled={!editMode}
                            >
                              {types.map((orderType) => (
                                <Option key={orderType.value}>
                                  {orderType.label}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </div>
                      </Col>
                    </Row>
                    <Row className="centerAlign">
                      <Col span={12}>
                        <div className="boxFieldTitle">
                          <label>Ply Range</label>
                          <p>Ply count that can be processed by this product</p>
                        </div>
                      </Col>
                      <Col span={12}>
                        <div className="boxFormType">
                          <Form.Item
                            name="ply_range"
                            rules={[
                              {
                                validator: () =>{
                                  if(!switchFetchOrdersfromERP && !selectedRange.length)
                                  {
                                    return Promise.reject("This field is required!")
                                  }
                                  return Promise.resolve();
                                }
                              }
                            ]}
                            className="selectForm"
                            initialValue={
                              selectedRange.length ? selectedRange[0] : []
                            }
                          >
                            <div class="checkboxFilt">
                              {productTypes === "reel" ||
                              productTypes === "both" ? (
                                <Checkbox.Group
                                  value={selectedRange}
                                  onChange={handleCheckboxChange}
                                  style={{ width: "100%" }}
                                  // disabled={action === "view"}
                                  disabled={!editMode}
                                >
                                  <Row gutter={16}>{checkboxes}</Row>
                                </Checkbox.Group>
                              ) : (
                                <Checkbox
                                  value={1}
                                  checked={selectedRange.includes("1")}
                                  disabled={!editMode}
                                  onChange={(e) =>{
                                    // setSelectedRange(
                                    //   e.target.checked ? ["1"] : []
                                    // )
                                    const value = e.target.checked ? ["1"] : [];

                                    setSelectedRange(value)
                                    form.setFieldsValue({ ply_range: value });
                                  }
                                  }
                                >
                                  <span
                                    style={{
                                      color: "#323130",
                                      fontSize: "14px",
                                      fontFamily: "var(--sf-pro-text)",
                                      fontStyle: "normal",
                                    }}
                                  >
                                    {1}
                                  </span>
                                </Checkbox>
                              )}
                            </div>
                          </Form.Item>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>

                <Row gutter={[16, 16]}>
                  <Col span={8}>
                    <GroupTitle>
                      <h2>Other Information</h2>
                      <p>All Other information related to this product</p>
                    </GroupTitle>
                  </Col>
                  <Col span={16}>
                    <Row className="centerAlign">
                      <Col span={12}>
                        <div className="boxFieldTitle">
                          <label>Status</label>
                          <p>
                            The order for this product will only be recorded if
                            it's enabled
                          </p>
                        </div>
                      </Col>
                      <Col span={12}>
                        <div
                          className="boxFormType switchRadio"
                          style={{
                            justifyContent: "flex-end",
                            display: "flex",
                          }}
                        >
                          <Form.Item
                            name="status"
                            initialValue={product.status}
                          >
                            <Radio.Group
                              options={userStatusData}
                              onChange={handleStatusChange}
                              value={userStatus}
                              optionType="button"
                              buttonStyle="solid"
                              disabled={!editMode}
                            />
                          </Form.Item>
                        </div>
                      </Col>
                    </Row>
                    <Row className="centerAlign">
                      <Col span={12}>
                        <div className="boxFieldTitle">
                          <label>
                            Remarks <span>(Optional)</span>
                          </label>
                          <p>Extra information of this product</p>
                        </div>
                      </Col>
                      <Col span={12}>
                        <div className="boxFormType">
                          <GlobalSet>
                            <Form.Item
                              name="remarks"
                              rules={[
                                {
                                  max: 70,
                                  message:
                                    "Remarks can have a maximum of 70 characters",
                                },
                              ]}
                              className=""
                              initialValue={product.remarks}
                            >
                              <TextArea
                                maxLength={100}
                                style={{ height: 90 }}
                                disabled={!editMode}
                              />
                            </Form.Item>
                          </GlobalSet>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Form>
            </div>
          </HaberForm>
        </DetailFields>
      )}

      {/* <ModalPopup visible={isVisibleModal}>
        <div className="Popup-img">
          <img src={warning} alt="Warning" />
        </div>
        <div className="Popup-content">
          <span>Delete product?</span>
          <p>
            A product deleted once cannot be recovered. Are you sure you want to
            proceed?
          </p>
        </div>
        <div className="ant-modal-footer-section">
          <Button
            key="back"
            className="themeBtn-plane"
            onClick={() => modalClose()}
          >
            <div className="plusPopUpBorder">
              <Iconmoon
                icon="plus-sign"
                size={9}
                color="#EA655B"
                className="ant-ico-sec"
              />
            </div>
            Cancel
          </Button>

          <Button
            key="submit"
            className="themeBtn"
            onClick={() => modalConfirm()}
          >
            <Iconmoon icon="tick-mark" size={14} color="#ffff" />
            Confirm
          </Button>
        </div>
      </ModalPopup> */}
      {newStockSizeDrawer && (
        <AddNewSize
          visible={newStockSizeDrawer}
          onClose={onCloseAddNewStock}
          productCode={productCode}
          productSpec={product.product_spec}
          rendering={setRendering}
          isAddNewStockClicked={isAddNewStockClicked}
          isViewStockClicked={isViewStockClicked}
          isEditStockClicked={isEditStockClicked}
          selectedStockSizeRow={selectedStockSizeRow}
          selectedStockSize={
            stockSizesListRawData.filter(
              (stockSize) => stockSize.id == selectedStockSize
            )[0]
          }
          toasterAction={setActionToaster}
          showToaster={showToaster}
        ></AddNewSize>
      )}

      <ConfirmationModal
        visible={visible}
        icon={warning}
        cancelAction={modalCancel}
        confirmAction={modalConfirm}
      >
        <span>Are you sure?</span>
        <p>
          You have pending changes on this page, are you sure you want to leave?
        </p>
      </ConfirmationModal>

      <ConfirmationModal
        visible={viewDelete}
        icon={warning}
        cancelAction={modalCancelDelete}
        confirmAction={modalConfirmDelete}
        param={productCode}
      >
        <span>Delete product?</span>
        <p>
          A product deleted once cannot be recovered. Are you sure you want to
          proceed?
        </p>
      </ConfirmationModal>

      {/* {success && (
        <AlertContainer
          color="green toaster"
          icon={alertGreen}
          msg="Product updated successfully"
        />
      )}

      {error && (
        <AlertContainer
          color="red toaster"
          icon={alertRed}
          msg="Error while updating product"
        />
      )}
      {deleteError && (
        <AlertContainer
          color="red toaster"
          icon={alertRed}
          msg="This product cannot be deleted as it has orders associated with it. You can disable it for further use."
        />
      )} */}

      {visibleToaster && !actionToaster.error && (
        <AlertContainer
          color="green toaster"
          icon={alertGreen}
          msg={actionToaster.msg}
        />
      )}
      {visibleToaster && actionToaster.error && (
        <AlertContainer
          color="red toaster"
          icon={alertRed}
          msg={actionToaster.msg}
        />
      )}
    </RightLayoutContainer>
  ) : (
    <></>
  );
};

export default EditProductsRecords;